exports = module.exports = require("./../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.contentContainer--3CVpW8KQ{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}.message--3KKFZVfO{text-align:center;margin:2rem;font-size:1.5rem}.firstMessage--2MTUDRlV,.secondMessage--2t2DRZnA{-webkit-animation:fadeInAndOut 3s ease both;animation:fadeInAndOut 3s ease both;animation-delay:.5s}@keyframes fadeInAndOut{0%{opacity:0;transform:translateX(.5rem)}10%{opacity:1;transform:translateY(0)}90%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateX(.5rem)}}", ""]);

// exports
exports.locals = {
	"contentContainer": "contentContainer--3CVpW8KQ",
	"message": "message--3KKFZVfO",
	"firstMessage": "firstMessage--2MTUDRlV",
	"secondMessage": "secondMessage--2t2DRZnA"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/timeclock/userhub/home/ClockIn/FirstClockIn/Message/styles.scss
// module id = 1072
// module chunks = 0